module.exports = __webpack_public_path__ + "img/album07_25.e1333cb9.jpg";